"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ronchi-dei-legionari": {
    "0fae9094": [{
      "hkey": "a56872e1",
      "slug": "ronchi-dei-legionari",
      "name": "Ronchi dei Legionari",
      "primary": true,
      "skipSearch": false
    }],
    "cave-di-selz": [{
      "hkey": "a56872e1",
      "slug": "ronchi-dei-legionari",
      "name": "Ronchi dei Legionari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7216c066": [{
      "hkey": "a56872e1",
      "slug": "ronchi-dei-legionari",
      "name": "Ronchi dei Legionari",
      "primary": true,
      "skipSearch": false
    }],
    "soleschiano": [{
      "hkey": "a56872e1",
      "slug": "ronchi-dei-legionari",
      "name": "Ronchi dei Legionari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "301df18d": [{
      "hkey": "a56872e1",
      "slug": "ronchi-dei-legionari",
      "name": "Ronchi dei Legionari",
      "primary": true,
      "skipSearch": false
    }],
    "vermegliano": [{
      "hkey": "a56872e1",
      "slug": "ronchi-dei-legionari",
      "name": "Ronchi dei Legionari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;